YP.OrgaBillsManager = function() {
    return {
        init: function() {
            moment.locale("fr");

            $('#bills-datepicker-start').datepicker().on('changeDate', function(event) {
                $('input[name="export_bill[begin]"]').val(moment(event.date).unix());
            });

            $('#bills-datepicker-end').datepicker().on('changeDate', function(event) {
                $('input[name="export_bill[end]"]').val(moment(event.date).unix());
            });         
                
        },
    };
};

window.addEventListener("load", function(){
    YP.OrgaBillsManager().init();
});


